"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arce": {
    "murata": [{
      "hkey": "b72bd42c",
      "slug": "arce",
      "name": "Arce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05a261c7": [{
      "hkey": "b72bd42c",
      "slug": "arce",
      "name": "Arce",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "b72bd42c",
      "slug": "arce",
      "name": "Arce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fae562e4": [{
      "hkey": "934c4df9",
      "slug": "collealto",
      "name": "Collealto",
      "primary": true,
      "skipSearch": false
    }],
    "colle-alto": [{
      "hkey": "934c4df9",
      "slug": "collealto",
      "name": "Collealto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ff5d6ffa": [{
      "hkey": "b72bd42c",
      "slug": "arce",
      "name": "Arce",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;